"use strict";
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.RoamClient = void 0;
class RoamClient {
    post(body) {
        throw new Error("Not Implemented");
    }
    createBlock({ parentUid, order, text, uid, }) {
        return this.post({
            location: {
                "parent-uid": parentUid,
                order,
            },
            block: {
                string: text,
                uid,
            },
            action: "create-block",
        }).then((r) => r[0]);
    }
    createAttribute({ key, value, parentUid, }) {
        return this.appendBlock({
            text: `${key}:: ${value}`,
            parentUid,
        });
    }
    createPage(page) {
        return this.post({
            page,
            action: "create-page",
        }).then((r) => r[0]);
    }
    deleteBlock(block) {
        return this.post({
            block,
            action: "delete-block",
        }).then((r) => r);
    }
    deletePage(page) {
        return this.post({
            page,
            action: "delete-page",
        }).then((r) => r);
    }
    moveBlock({ parentUid, order, uid, }) {
        return this.post({
            location: {
                "parent-uid": parentUid,
                order,
            },
            block: {
                uid,
            },
            action: "move-block",
        }).then((r) => r);
    }
    pull(params) {
        return this.post({
            selector: params.selector || "[*]",
            uid: params.uid,
            action: "pull",
        }).then((r) => r);
    }
    q({ query, inputs }) {
        return this.post({
            action: "q",
            query,
            inputs,
        }).then((r) => r.map((res) => res[0]));
    }
    updateBlock({ uid, text, open, }) {
        return this.post({
            block: {
                string: text || "",
                uid,
                open,
            },
            action: "update-block",
        }).then((r) => r);
    }
    updatePage(page) {
        return this.post({
            page,
            action: "update-page",
        }).then((r) => r);
    }
    findOrCreatePage(pageName, uid) {
        return __awaiter(this, void 0, void 0, function* () {
            const queryResults = yield this.q({
                query: `[:find (pull ?e [:block/uid]) :where [?e :node/title "${pageName}"]]`,
            });
            if (queryResults.length === 0) {
                const basicPage = yield this.createPage({
                    title: pageName,
                    uid,
                });
                return basicPage.uid;
            }
            return queryResults[0]["block/uid"];
        });
    }
    findOrCreateBlock({ text, parentUid, }) {
        return __awaiter(this, void 0, void 0, function* () {
            const queryResults = yield this.q({
                query: `[:find (pull ?c [:block/uid]) :where [?c :block/string "${text}"] [?p :block/children ?c] [?p :block/uid "${parentUid}"]]`,
            });
            if (queryResults.length === 0) {
                return yield this.appendBlock({ text, parentUid });
            }
            return queryResults[0]["block/uid"];
        });
    }
    upsertBlock({ uid, text, parentUid, }) {
        return __awaiter(this, void 0, void 0, function* () {
            const queryResults = yield this.q({
                query: `[:find (pull ?b [:block/uid]) :where [?b :block/uid "${uid}"]]`,
            });
            if (queryResults.length === 0) {
                return this.appendBlock({ text, parentUid, uid }).then(() => true);
            }
            return this.updateBlock({ uid, text });
        });
    }
    appendBlock({ text, parentUid, uid, }) {
        return __awaiter(this, void 0, void 0, function* () {
            const parents = yield this.q({
                query: `[:find (pull ?p [:block/children, :block/uid]) :where [?p :block/uid "${parentUid}"]]`,
            });
            if (parents.length === 0 || !parents[0]) {
                throw new Error(`No existing parent of uid ${parentUid}`);
            }
            const children = parents[0]["block/children"];
            const basicPage = yield this.createBlock({
                text,
                parentUid,
                order: (children === null || children === void 0 ? void 0 : children.length) || 0,
                uid,
            });
            return basicPage.uid;
        });
    }
}
exports.RoamClient = RoamClient;
